export default __webpack_public_path__ + "static/media/postImage3.c88faf5d.png";